// Components
import SignUpForm, { Fields, Submit, Errors } from './SignUpForm'

export default Object.assign(SignUpForm, {
  Fields,
  Submit,
  Errors,
})
